import homeFill from '@iconify/icons-eva/home-fill'
import personFill from '@iconify/icons-eva/person-fill'
import settings2Fill from '@iconify/icons-eva/settings-2-fill'
import sunFill from '@iconify/icons-eva/sun-fill'
import moonFill from '@iconify/icons-eva/moon-fill'
import { Icon } from '@iconify/react'
import { Avatar, Box, Button, Divider, Typography, Switch, Stack } from '@material-ui/core'
// material
import { alpha } from '@material-ui/core/styles'
import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import useApi from 'src/hooks/useApi'
import useAuth from 'src/hooks/useAuth'
import useSettings from 'src/hooks/useSettings'
// components
import { MIconButton } from '../../components/@material-extend'
import MenuPopover from '../../components/MenuPopover'

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: homeFill,
    linkTo: '/',
  },
  {
    label: 'Profile',
    icon: personFill,
    linkTo: '#',
  },
  {
    label: 'Settings',
    icon: settings2Fill,
    linkTo: '#',
  },
]

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null)

  const [open, setOpen] = useState(false)
  const [mounted, setMounted] = useState(false)
  const [busy, setBusy] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const api = useApi()
  const auth = useAuth()
  const history = useHistory()
  const { themeMode, toggleMode } = useSettings()

  useEffect(() => {
    if (!mounted) {
      setMounted(true)
      api.getUser()
    }
  }, [mounted, api])

  function _logout() {
    auth.logout(() => history.push('/'))
  }

  function _activateSite(siteId) {
    setBusy(true)
    localStorage.clear();
    api.activateSite({ siteId }, () => {
      setBusy(false)
      window.location.reload()
    })
  }

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
          }),
        }}
      >
        <Avatar
          alt="My Avatar"
          src={'/static/mock-images/avatars/avatar_default.jpg'}
        />
      </MIconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {api.user ? api.user.email : ''}
          </Typography>
        </Box>

        {/* Theme Toggle */}
        <Box sx={{ px: 2.5, py: 1 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" alignItems="center" spacing={1}>
              <Icon icon={themeMode === 'dark' ? moonFill : sunFill} width={20} height={20} />
              <Typography variant="body2">
                {themeMode === 'dark' ? 'Dark Mode' : 'Light Mode'}
              </Typography>
            </Stack>
            <Switch
              size="small"
              checked={themeMode === 'light'}
              onChange={toggleMode}
            />
          </Stack>
        </Box>

        <Divider sx={{ my: 1 }} />

        {api.user && api.user.sites ? (
          <Box sx={{ p: 2, pt: 1.5 }} style={{ overflow: "scroll", maxHeight: 400 }}>
            {api.user.sites.map((s) => {
              return (
                <Button
                  fullWidth
                  color={s.id == api.user.activeSite ? 'primary' : 'inherit'}
                  variant="text"
                  key={s.id}
                  disabled={busy}
                  onClick={
                    s.id == api.user.activeSite
                      ? null
                      : () => _activateSite(s.id)
                  }
                >
                  {s.name}
                </Button>
              )
            })}
          </Box>
        ) : null}

        <Divider />

        <Button fullWidth color="inherit" variant="text" onClick={_logout}>
          Logout
        </Button>
      </MenuPopover>
    </>
  )
}
